document.addEventListener('DOMContentLoaded', function () {
  const MAX_HEIGHT = 200; // ajustez selon vos besoins

  document.querySelectorAll('.product-details rte-formatter').forEach(function (desc) {
    if (desc.scrollHeight <= MAX_HEIGHT) return;

    desc.style.maxHeight = MAX_HEIGHT + 'px';
    desc.style.overflow = 'hidden';

    const toggle = document.createElement('button');
    toggle.className = 'product-description__toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.innerHTML = '<span class="toggle-icon">+</span><span class="toggle-label">Voir plus</span>';

    toggle.addEventListener('click', function () {
      const expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        desc.style.maxHeight = MAX_HEIGHT + 'px';
        toggle.setAttribute('aria-expanded', 'false');
        toggle.innerHTML = '<span class="toggle-icon">+</span><span class="toggle-label">Voir plus</span>';
      } else {
        desc.style.maxHeight = desc.scrollHeight + 'px';
        toggle.setAttribute('aria-expanded', 'true');
        toggle.innerHTML = '<span class="toggle-icon">−</span><span class="toggle-label">Voir moins</span>';
      }
    });

    desc.parentNode.insertBefore(toggle, desc.nextSibling);
  });
});
